import localforage from "localforage";
import * as PIXI from "pixi.js";

export const gameSettings = localforage.createInstance({
    name: "gameSettings"
});